import { createContext, useContext } from "react";

// Shop global display settings (star icon, corners, reviewer avatar style) as
// returned by the guest shop endpoint; null until loaded / when unavailable.
export const GlobalDisplayContext = createContext(null);

export const useGlobalDisplay = () => useContext(GlobalDisplayContext);
